import { user_bug_report_dto } from '@Api';
import { ReasonType, UserBugReport } from '@Models';
import { injectable } from 'inversify';

@injectable()
export class UserBugReportMapper {
  mapDto(item: UserBugReport): user_bug_report_dto {
    return {
      reason_type: this.mapReasonType(item.reasonType),
      report: item.report,
      army_id: item.armyId,
      unit_id: item.unitId,
      unit_option_id: item.unitOptionId,
      value: item.value,
    };
  }

  mapReasonType(item: ReasonType): user_bug_report_dto.reason_type {
    switch (item) {
      case ReasonType.MissingOption:
        return user_bug_report_dto.reason_type.MISSING_OPTION;
      case ReasonType.Cost:
        return user_bug_report_dto.reason_type.COST;
      case ReasonType.Translate:
        return user_bug_report_dto.reason_type.TRANSLATE;
    }

    return user_bug_report_dto.reason_type.OTHER;
  }
}
